export const AUTH_CONFIG = {
  authority: process.env.REACT_APP_JUMPCLOUD_AUTHORITY,
  client_id: process.env.REACT_APP_JUMPCLOUD_CLIENT_ID,
  client_secret: process.env.REACT_APP_JUMPCLOUD_CLIENT_SECRET,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  response_type: 'code',
  scope: 'openid profile email',
};
